/**
 * @return {undefined | HTMLIFrameElement}
 */
module.exports = function getRoiCalculatorIframe() {
    const roiCalculatorIframe = document.querySelector('[data-component="roi-calculator-iframe"]');

    if (roiCalculatorIframe instanceof HTMLIFrameElement) {
        return roiCalculatorIframe;
    }
}
